(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("us-common-utils"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "us-common-utils"], factory);
	else if(typeof exports === 'object')
		exports["component-whiteboard"] = factory(require("react"), require("prop-types"), require("us-common-utils"));
	else
		root["component-whiteboard"] = factory(root[undefined], root[undefined], root[undefined]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition